import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const PaperPlaneIcon = (p: IconProps) => <Icon {...p}><path d="M22 2 11 13" /><path d="M22 2 15 22l-4-9-9-4 20-7z" /></Icon>
